import { render, staticRenderFns } from "./PresentationViewer.vue?vue&type=template&id=6bd5fdeb&scoped=true&"
import script from "./PresentationViewer.vue?vue&type=script&lang=js&"
export * from "./PresentationViewer.vue?vue&type=script&lang=js&"
import style0 from "./PresentationViewer.vue?vue&type=style&index=0&id=6bd5fdeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5fdeb",
  null
  
)

export default component.exports